import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/utils';
import { avatarVariants } from '@/components/ui/avatar-variants';

export type AvatarProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof avatarVariants> & {
    src?: string | null;
    alt?: string;
    initials?: string;
  };

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, size, src, alt = '', initials = '??', ...props }, ref) => {
    const [imageFailed, setImageFailed] = React.useState(false);
    const showImage = Boolean(src) && !imageFailed;

    React.useEffect(() => {
      setImageFailed(false);
    }, [src]);

    return (
      <div ref={ref} className={cn(avatarVariants({ size }), className)} {...props}>
        {showImage ? (
          <img
            alt={alt}
            draggable={false}
            onError={() => setImageFailed(true)}
            src={src ?? undefined}
          />
        ) : (
          initials
        )}
      </div>
    );
  },
);
Avatar.displayName = 'Avatar';

export { Avatar };
